import { ErrorResponse, FleetReportData } from '../../../../@types';

export interface ReportsState {
  entities: FleetReportData[] | null;
  display: FleetReportData[] | null;
  selected: FleetReportData | null;
  error: ErrorResponse | null;
  loading: boolean;
}

export const initialState = {
  entities: null,
  display: null,
  selected: null,
  error: null,
  loading: false,
};
